
module.exports =
    [{
        "group": "Customer",
        "selected": false,
        "name": "Main Menu",
        "base": true,
        "id": "main_menu",
        "icon": "shutter_speed",
        "list": [
            { "selected": true, "name": "TopPage", "id": "top_page" },
            // { "selected": true, "name": "BankStatus", "id": "bank_status" },
            // { "selected": true, "name": "RackStatus", "id": "rack_status" },
            // { "selected": true, "name": "PackStatus", "id": "pack_status" },
            // { "selected": true, "name": "CellStatus", "id": "cell_status" }
        ],
    }]


// WEBPACK FOOTER //
// ./src/core/routes.js